import { Stack } from '@mui/material';
import {
    Pagination,
    SortButton,
    TopToolbar,
    useListContext,
} from 'react-admin';
import { NoteCreate } from './NoteCreate';
import { NotesIterator } from './NotesIterator';

export const NotesLayout = ({
    reference,
}: {
    reference: 'member' | 'mission';
}) => {
    const { error, isPending } = useListContext();
    if (isPending || error) return null;
    return (
        <Stack mt={2} gap={2}>
            <NoteCreate reference={reference} />
            <TopToolbar>
                <SortButton fields={['createdAt', 'updatedAt']} />
            </TopToolbar>
            <NotesIterator />
            <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
        </Stack>
    );
};
